import React from "react";
import "./BecomeAnAgent.css";
import GA from "../functions/GA";
import { Link } from "react-router-dom";
import baa from "../../assets/vids/baa.mp4";
import emptyCaptions from "../../components/empty-captions.vtt";

export default function BecomeAnAgent({ responsiveStatus }) {
  const openInNewTab = (url) => {
    window.open(url, "_blank").focus();
  };

  return (
    <div
      style={{
        position: "relative",
        minHeight:
          responsiveStatus === "isDesktop"
            ? "70vh"
            : responsiveStatus === "isTablet" ||
              responsiveStatus === "isTabletLandscape"
            ? ""
            : "",
        overflow: "hidden",
        color: "white",
      }}
    >
      {/* Background Video */}
      <video
        autoPlay
        loop
        muted
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
          zIndex: -1,
        }}
      >
        <track
          kind="captions"
          src={emptyCaptions}
          srcLang="en"
          label="English"
        />
        {/* <source src="http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/Sintel.mp4" type="video/mp4" /> */}
        <source src={baa} type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems:
            responsiveStatus === "isDesktop"
              ? "center"
              : responsiveStatus === "isTablet" ||
                responsiveStatus === "isTabletLandscape"
              ? "center"
              : "left",
          height:
            responsiveStatus === "isDesktop"
              ? "70vh"
              : responsiveStatus === "isTablet" ||
                responsiveStatus === "isTabletLandscape"
              ? "45vh"
              : "",
          padding: "5px",
          zIndex: 1,
          backdropFilter: "brightness(1.9) contrast(40%)",
          background: "rgba(255, 255, 255, 0.5)",
        }}
      >
        <div
          className={`${
            responsiveStatus === "isDesktop"
              ? "row "
              : responsiveStatus === "isTablet" ||
                responsiveStatus === "isTabletLandscape"
              ? "row"
              : "row-m w-100"
          }`}
          style={{ maxWidth: "1000px" }}
        >
          <div
            className="col-md-6 col-12"
            style={{
              paddingLeft:
                responsiveStatus === "isDesktop"
                  ? ""
                  : responsiveStatus === "isTablet" ||
                    responsiveStatus === "isTabletLandscape"
                  ? "66px"
                  : "45px",
            }}
          >
            <div style={{ flex: 1, maxWidth: "600px" }}>
              {responsiveStatus === "isMobile" ||
              responsiveStatus === "isSmallMobile" ? (
                <p
                  style={{
                    color: "#000000",
                    fontSize: "16px",
                    // lineHeight: "1.6",
                    fontWeight: 600,
                    whiteSpace: "nowrap",
                  }}
                >
                  <span
                    style={{
                      textDecoration: "underline",
                      textDecorationColor: "blue",
                      textUnderlineOffset: "8px",
                    }}
                  >
                    Become an Ag
                  </span>
                  ent!
                </p>
              ) : (
                <p
                  style={{
                    color: "#000000",
                    fontSize: "24px",
                    // lineHeight: "1.6",
                    fontWeight: 500,
                    whiteSpace: "nowrap",
                    marginBottom: "1em",
                  }}
                >
                  <span className="blue-underline">Become</span> an Agent!
                </p>
              )}
              <p
                style={{
                  color: "#515050",
                  fontSize: "16px",
                  // lineHeight:
                  //   responsiveStatus === "isDesktop"
                  //     ? ""
                  //     : responsiveStatus === "isTablet" ||
                  //       responsiveStatus === "isTabletLandscape"
                  //     ? ""
                  //     : "",
                  marginTop: "1em",
                  paddingBottom: "0px",
                }}
              >
                Save your customers money by offering our wide range of
                policies.
              </p>
              <p
                style={{
                  color: "#515050",
                  fontSize: "16px",
                  // lineHeight:
                  //   responsiveStatus === "isDesktop"
                  //     ? "0.6"
                  //     : responsiveStatus === "isTablet" ||
                  //       responsiveStatus === "isTabletLandscape"
                  //     ? "0.6"
                  //     : "1.2",
                  marginBottom: "20px",
                }}
              >
                To get started, select your state below.
              </p>

              <div
                style={{
                  position: "relative",
                  width:
                    responsiveStatus === "isDesktop"
                      ? "70%"
                      : responsiveStatus === "isTablet" ||
                        responsiveStatus === "isTabletLandscape"
                      ? "70%"
                      : "100%",
                  marginBottom: "20px",
                }}
              >
                <div
                  style={{
                    display: `${
                      responsiveStatus === "isDesktop"
                        ? "block"
                        : responsiveStatus === "isTablet" ||
                          responsiveStatus === "isTabletLandscape"
                        ? "block"
                        : "flex"
                    }`,
                    alignItems: "center",
                  }}
                >
                  <label
                    htmlFor="state-select"
                    style={{ fontSize: "12px", fontWeight: "bold" }}
                  >
                    Select State
                  </label>
                  <select
                    id="state-select"
                    name="state-select"
                    aria-label="Select your state"
                    onChange={(e) => {
                      GA(
                        "BAA_Dropdown",
                        "User selected an option from the BAA_Dropdown on homescreen"
                      );

                      // redirect on selection (if desired)
                      const selectedUrl = e.target.value;
                      if (selectedUrl) {
                        window.location.href = selectedUrl;
                      }
                    }}
                    style={{
                      flex: 1,
                      padding: "8px 10px",
                      borderRadius: "5px",
                      border: "1px solid #ccc",
                      appearance: "auto",
                      backgroundColor: "white",
                      width: "100%",
                      height: "35px",
                      fontSize: "12px",
                    }}
                  >
                    <option value="" disabled selected>
                      Select
                    </option>
                    <option value="https://baa.uaig.net/fl/index.php">
                      Florida
                    </option>
                    <option value="https://baa.uaig.net/ga/index.php">
                      Georgia
                    </option>
                    <option value="https://baa.uaig.net/tx/index.php">
                      Texas
                    </option>
                  </select>

                  <button
                    style={{
                      marginLeft: "10px",
                      backgroundColor: "#007BFF",
                      color: "white",
                      border: "none",
                      borderRadius: "5px",
                      padding: "8px 20px",
                      cursor: "pointer",
                      fontSize: "12px",
                      marginTop: `${
                        responsiveStatus === "isDesktop"
                          ? "1em"
                          : responsiveStatus === "isTablet" ||
                            responsiveStatus === "isTabletLandscape"
                          ? "1em"
                          : "1em"
                      }`,
                    }}
                    // onClick={() => {
                    //   const selectElement = document.querySelector("select");
                    //   if (selectElement && selectElement.value) {
                    //     openInNewTab(selectElement.value);
                    //   }
                    // }}
                  >
                    Get Started
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-12">
            <div
              style={{
                flex: 1,
                display: "flex",
                justifyContent: `${
                  responsiveStatus === "isDesktop"
                    ? "end"
                    : responsiveStatus === "isTablet" ||
                      responsiveStatus === "isTabletLandscape"
                    ? "end"
                    : "center"
                }`,
              }}
            >
              <img
                src={require("../../assets/img/img1.png")}
                alt="Description"
                style={{
                  maxWidth: "65%",
                  borderRadius: "10px",
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
